import ApiService from 'Services/ApiService'

export default {
    list(query = null) {
        return ApiService.get('patients', query)
    },
    get(id) {
        return ApiService.get(`patients/${id}`)
    },
    store(patient) {
        return ApiService.post('patients', patient)
    },
    update(patient) {
        return ApiService.put(`patients/${patient.id}`, patient)
    },
    delete(id) {
        return ApiService.delete(`patients/${id}`)
    }
}